import { Box } from '@mui/material';
import { useCallback } from 'react';
import { FormFieldsData, ModalForm } from 'framework/form';
import { SideDrawer } from 'framework/ui/mui-builder';
import FormFocusTimeDayTimeline from './shared/FocusTimeDayTimeline/FormFocusTimeDayTimeline';
import useFocusTimeSlots from './useFocusTimeSlots';
import { FocusTimeSlot } from './types';
import FocusTimeDrawerSaveButton from './shared/buttons/FocusTimeDrawerSaveButton';

type FocusTimeDrawerProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
}>;

const DRAWER_CONTENT_SX = {
  width: '100%',
  height: '90%',
  minHeight: 0,
} as const;

const FORM_CONTENT_SX = {
  display: 'flex',
  height: '100%',
  minHeight: 0,
  flexDirection: 'column',
} as const;

const TIMELINE_WRAPPER_SX = {
  minHeight: 0,
  flex: '1 1 auto',
} as const;

const FOCUS_TIME_SCHEDULES_SOURCE = 'schedules';

const FocusTimeDrawer = ({ isOpen, onClose }: FocusTimeDrawerProps) => {
  const { slots, currentMinutes, saveSlots } = useFocusTimeSlots();

  const getData = useCallback(
    () =>
      Promise.resolve({
        [FOCUS_TIME_SCHEDULES_SOURCE]: slots,
      }),
    [slots],
  );

  const submitForm = (values: FormFieldsData<{ schedules?: FocusTimeSlot[] }>) =>
    saveSlots(values[FOCUS_TIME_SCHEDULES_SOURCE] || []);

  return (
    <SideDrawer
      title="Plan My Day"
      isOpen={isOpen}
      onClose={onClose}
      width={600}
      content={
        <Box sx={DRAWER_CONTENT_SX}>
          {isOpen ? (
            <ModalForm
              closeModal={onClose}
              modalOpen={isOpen}
              isHideDefaultButtons
              getDataFunc={getData}
              submitFormFunc={submitForm}
              handleDirty={false}
            >
              <Box sx={FORM_CONTENT_SX}>
                <Box sx={TIMELINE_WRAPPER_SX}>
                  <FormFocusTimeDayTimeline
                    source={FOCUS_TIME_SCHEDULES_SOURCE}
                    slots={slots}
                    currentMinutes={currentMinutes}
                  />
                </Box>
                <FocusTimeDrawerSaveButton />
              </Box>
            </ModalForm>
          ) : null}
        </Box>
      }
    />
  );
};

export default FocusTimeDrawer;
